import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import { TutorialsModel } from '../../models/TutorialsModel';

interface ITutorialsService {
  getTutorials: (
    route: string | undefined,
    categoryId: string | undefined,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<TutorialsModel>>;
}

export const tutorialsService: ITutorialsService = {
  getTutorials(route, categoryId, axiosConfig) {
    const url = route
      ? `${config.benefitApiUrl}/tutorials?route=${route}`
      : `${config.benefitApiUrl}/tutorials?categoryId=${categoryId}`;
    return ajax.get<TutorialsModel>(url, axiosConfig);
  },
};
